import keycloak from './keycloak';

const API_BASE = '/api/portal';

export class ApiError extends Error {
  constructor(status, body) {
    super(body?.message || `Request failed (${status})`);
    this.status = status;
    this.code = body?.code;
    this.body = body;
  }
}

export class TransactionSigningRequired extends Error {
  constructor(body) {
    super('Transaction signing required');
    this.threshold = body?.threshold;
    this.body = body;
  }
}

async function request(method, path, body = null, extraHeaders = {}) {
  try { await keycloak.updateToken(5); } catch { /* ignore */ }

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${keycloak.token}`,
    ...extraHeaders,
  };

  const opts = { method, headers };
  if (body) opts.body = JSON.stringify(body);

  const res = await fetch(`${API_BASE}${path}`, opts);

  if (res.status === 428) {
    throw new TransactionSigningRequired(await res.json());
  }

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new ApiError(res.status, data);
  }

  return data;
}

const api = {
  get: (path) => request('GET', path),
  post: (path, body, headers) => request('POST', path, body, headers),
  put: (path, body) => request('PUT', path, body),
  del: (path) => request('DELETE', path),

  // Payment with optional signing token + idempotency
  initiatePayment: (body, signingToken, idempotencyKey) => {
    const headers = {};
    if (signingToken) headers['X-Transaction-Signing-Token'] = signingToken;
    if (idempotencyKey) headers['Idempotency-Key'] = idempotencyKey;
    return request('POST', '/payments', body, headers);
  },
};

export default api;
